<template>
    <span>
        <FormsAutocomplete 
            @onShowFormCreate="(value) => showFormCreate = value"
            v-model="model"  
            :item="collection"
            :label="label"
            :clearable="clearable"
            :disabled="disabled"
            :multiple="multiple"
            :show-add="showAdd"
            :error-messages="errorMessages"
            :dense="dense"
            store-action="domainAmbience/ActionGetAmbiences"
            :filters.sync="applyFilter"
            :load-data="loadData"
			      columns="id,name,campus_id,ambience_type_id"
			      item-text="name_complete"
        />

        <sys-register-ambience @onCompleted="newItem" :model="{}" v-bind:show.sync="showFormCreate" />

    </span>
</template>

<script setup>

import { ref, computed, defineEmits, defineProps } from 'vue'

//Events
const emit = defineEmits(['input', 'update:item'])

//Props
const props = defineProps({
        label: { type: String, default: 'Ambiente'},
        clearable: { type: Boolean, required: false },
        disabled: { type: Boolean, required: false },
        dense: { type: Boolean, required: false },
        showAdd: { type: Boolean, required: false },
        multiple: { type: Boolean, required: false },
        value: { type: [String, Number, Object, Array] },
        item: { type: Object, required: false },
        filters: { type: Object, required: false },
        errorMessages: { type: Array, required: false },
        loadData: { type: Boolean, default: false },
    })

//Data
const showFormCreate = ref(false)

//Computed
const model = computed({
  get: () => props.value,
  set: val => emit('input', val)
})

const collection = computed({
  get: () => props.item,
  set: val => emit('update:item', val)
})

const applyFilter = computed({
  get () {
    if (props.filters) {
      // aplicar outros filtros se necessário
      return props.filters
    }
  }
})

function newItem(val) {
  model.value = val.id
  collection.value = { id: val.id, name: val.name }
  showFormCreate.value = false
}

</script>